import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

type HeadProps = {
  title: string;
  description: string;
};

export const HeadTags = ({ title, description }: HeadProps) => {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  return (
    <>
      <html lang="en" />
      <title>{`${title} - ${site.siteMetadata.title}`}</title>
      <meta name="description" content={description} />
    </>
  );
};
